/*
 *
 * AdminHelpfulDataTool actions
 *
 */

import { createAction } from 'redux-actions';
import {
  PROCESSING,
  GET_ADMIN_USERS,
  GET_ADMIN_USERS_RESULT,
  UPDATE_USER_ROLE,
  UPDATE_USER_ROLE_RESULT,
} from './constants';

export const processing = createAction(PROCESSING);
export const getAdminUsers = createAction(GET_ADMIN_USERS);
export const getAdminUsersResult = createAction(GET_ADMIN_USERS_RESULT);
export const updateAdminUserRole = createAction(UPDATE_USER_ROLE);
export const updateAdminUserRoleResult = createAction(UPDATE_USER_ROLE_RESULT);
